"use strict";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/*
function CollectCategoryData(data)
{
	var ret = {};
	
	ret.title = data.title;
	
	ret.selectedcategories = [];
	for (var i = 0; i < data.categories.length; ++i)
	{
		if (data.categories[i].selected === true) ret.selectedcategories.push(data.categories[i].id);
	}
	
	ret.published = data.published || false;
	
	return ret;
}*/

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class ChampCategoryEditController
{
	/*@ngInject*/
	constructor($state, $location, $stateParams, $log, $http, Modal)
	{
		//console.log("cceController " + $stateParams.id);
		if (!$stateParams.id) 
			return $state.go("home");

		this.$state = $state;
		this.$http = $http;
		this.Modal = Modal;

		this.categoryId = $stateParams.id;

		this.data = {};

		$http.post("/api/backend/champs/categorydata/" + this.categoryId)
		.then(response =>
		{
			//console.log(response.data);
			this.c = response.data;

			//for (var attrname in response.data) {
			//	this.data[attrname] = response.data[attrname];
			//}
		});
	}

	AddRace(index, race)
	{
		this.$http.post("/api/backend/champs/addrace/" + this.categoryId + "/" + race.raceid)
		.then(response => {
			this.$state.go("champcategoryedit", { id: this.categoryId }, { reload: true });
		});
	}
		
	RemoveRace(index, race)
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/backend/champs/removerace/" + this.categoryId + "/" + race.raceid)
			.then(response => {
				this.$state.go("champcategoryedit", { id: this.categoryId }, { reload: true });
			});
		})({
			html: [
				"<strong>{{vm.title}}</strong>",
				"¿Seguro que deseas eliminar la carrera?" 
			],
			vm: {title: race.name}
		}/*Optional params here*/);
	}

	EditResult(index, race)
	{
		this.$state.go("champresultedit", { categoryId: this.categoryId, raceId: race.raceid });
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/champs/champ_categoryedit.controller.js